import { Link } from "react-router-dom";
import { Menu, Phone } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useSite } from "@/contexts/SiteContext";
import { trackEvent } from "@/components/Analytics";

export default function Header({ onMenuToggle }) {
  const { t } = useTranslation();
  const { company, contact } = useSite();

  return (
    <header className="sticky top-0 z-50 w-full header-glass">
      <div className="flex items-center justify-between px-5 lg:px-10 h-16">
        <div className="flex items-center gap-4">
          <button
            className="lg:hidden text-atelier-ink p-1"
            onClick={onMenuToggle}
            data-testid="header-menu-toggle"
            aria-label="Ouvrir le menu"
          >
            <Menu className="w-5 h-5" />
          </button>
          <Link to="/" className="flex items-center gap-2.5 group" data-testid="header-logo">
            {company?.logo_url && (
              <img
                src={company.logo_url}
                alt="AMAR SAHRAOUI"
                className="h-8 w-auto"
                style={{ mixBlendMode: "screen" }}
              />
            )}
            <h1 className="font-serif text-base lg:text-lg tracking-[0.18em] uppercase text-atelier-ink">
              AMAR SAHRAOUI
            </h1>
          </Link>
        </div>

        <div className="flex items-center gap-5">
          <span className="hidden md:inline label-tech text-[0.6rem] text-atelier-textFaint">
            {t("nav.about").toUpperCase()} · ORAN — ALGÉRIE
          </span>
          {contact?.phone && (
            <a
              href={`tel:${contact.phone.replace(/\s/g, "")}`}
              onClick={() => trackEvent("phone_click", { location: "header_desktop" })}
              className="hidden md:flex items-center gap-2 text-atelier-textDim hover:text-atelier-ink transition-colors"
              data-testid="header-phone"
            >
              <Phone className="w-3.5 h-3.5 text-atelier-ink" strokeWidth={1.5} />
              <span className="label-tech text-[0.66rem]">{contact.phone}</span>
            </a>
          )}
        </div>
      </div>
    </header>
  );
}
